import { isActivityToDisplay, isRouteToDisplay } from '../../../../utils/map/MapFeatureFilters';

export function enhanceActivityGeoJSONFeatures(geoJSON, display, showOnlyFirstVisits) {
  if (!geoJSON?.geo?.features) return geoJSON;

  const activityFeatures = geoJSON.geo.features.filter(
    (feature) =>
      feature.geometry.type === 'Point' &&
      !!isActivityToDisplay(feature) &&
      isRouteToDisplay(feature, display) &&
      (!showOnlyFirstVisits || !!feature.properties.isFirstVisit),
  );

  return {
    ...geoJSON,
    geo: {
      ...geoJSON.geo,
      features: activityFeatures,
    },
  };
}
